import { chartOfAccountsTypes, chartOfAccountsUtils } from 'app-components/flux/chart-of-accounts';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import store from 'app-components/utils/redux-store';

export function coaIncludedInList(coa, categoriesById, accountsById, stType) {
  switch (coa.type) {
    case chartOfAccountsTypes.CoaTypeEnum.CATEGORY: {
      const category = categoriesById.get(coa.id);
      if (category && category.isExcludedFromCategoryList) {
        return false;
      }
      break;
    }

    case chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT: {
      if (
        stType === scheduledTransactionsTypes.STTypeEnum.TRANSFER &&
        chartOfAccountsUtils.getBalanceAdjustmentString(coa.id) !== 'Transfer'
      ) {
        return false;
      }
      break;
    }

    case chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED: {
      if (stType === scheduledTransactionsTypes.STTypeEnum.INCOME) {
        return false;
      }
      break;
    }

    case chartOfAccountsTypes.CoaTypeEnum.ACCOUNT: {
      const account = accountsById.get(coa.id);
      if (
        !featureFlagsSelectors.getFeatureFlag(store.getState(), 'investmentTransactions') &&
        account?.type === 'INVESTMENT'
      ) {
        return false;
      }
      break;
    }

    default:
      break;
  }
  return true;
}
